/*
* General custom scripts
**/
import './components/header';
import './components/accesibility';
import './components/click-events';
import './components/unclick-mask';
import './components/pagination';
import './components/ratioVideos';
import './components/animations';
import './components/scrollToSection';
